import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface AnimatedCardProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  hover?: boolean;
  /** Default true. Set false when a parent (e.g. <Reveal>) handles the entrance animation. */
  animate?: boolean;
}

export function AnimatedCard({
  children,
  className,
  delay = 0,
  hover = true,
  animate = true,
}: AnimatedCardProps) {
  return (
    <div
      className={cn(
        "bg-card border border-border rounded-lg p-6",
        animate && "opacity-0 animate-fade-in-up",
        hover && "transition-all duration-300 hover:-translate-y-2 hover:shadow-glow-purple hover:border-gold/30",
        className,
      )}
      style={animate ? { animationDelay: `${delay}ms`, animationFillMode: "forwards" } : undefined}
    >
      {children}
    </div>
  );
}
